module.exports = __webpack_public_path__ + "img/nav_icon_pelvis.f604f28e.svg";